module.exports = __webpack_public_path__ + "img/icono-virtuales.48f77002.svg";